module.exports = {
	"modal": "findify-components-search--mobile-facets__modal",
	"filter-count": "findify-components-search--mobile-facets__filter-count",
	"filterCount": "findify-components-search--mobile-facets__filter-count",
	"back-button": "findify-components-search--mobile-facets__back-button",
	"backButton": "findify-components-search--mobile-facets__back-button",
	"header": "findify-components-search--mobile-facets__header",
	"body": "findify-components-search--mobile-facets__body",
	"footer": "findify-components-search--mobile-facets__footer",
	"title": "findify-components-search--mobile-facets__title",
	"facet-title": "findify-components-search--mobile-facets__facet-title",
	"facetTitle": "findify-components-search--mobile-facets__facet-title",
	"flex-fix": "findify-components-search--mobile-facets__flex-fix",
	"flexFix": "findify-components-search--mobile-facets__flex-fix",
	"selected-values": "findify-components-search--mobile-facets__selected-values",
	"selectedValues": "findify-components-search--mobile-facets__selected-values",
	"container": "findify-components-search--mobile-facets__container",
	"rating": "findify-components-search--mobile-facets__rating",
	"expand": "findify-components-search--mobile-facets__expand",
	"expanded-list": "findify-components-search--mobile-facets__expanded-list",
	"expandedList": "findify-components-search--mobile-facets__expanded-list",
	"range": "findify-components-search--mobile-facets__range",
	"facet-root": "findify-components-search--mobile-facets__facet-root",
	"facetRoot": "findify-components-search--mobile-facets__facet-root"
};